const customModuleType = {
  ADD_CUSTOM_MODULE: 'ADD_CUSTOM_MODULE',
  GET_CUSTOM_MODULE: 'GET_CUSTOM_MODULE',
  GET_CUSTOM_MODULE_BY_ID: 'GET_CUSTOM_MODULE_BY_ID',
  UNMOUNT_LIBRARY_LIST: 'UNMOUNT_LIBRARY_LIST',
  UNMOUNT_GROUP_LIST: 'UNMOUNT_GROUP_LIST',
  GET_CUSTOM_MODULE_OPTION: 'GET_CUSTOM_MODULE_OPTION',
  GET_CUSTOM_MODULE_GROUP: 'GET_CUSTOM_MODULE_GROUP',
  GET_CUSTOM_MODULE_FOR_OPTION: 'GET_CUSTOM_MODULE_FOR_OPTION',
  UNMOUNT_LIBRARY: 'UNMOUNT_LIBRARY',
  LIBRARY_PAGES: 'LIBRARY_PAGES',
  GET_CUSTOM_MODULE_LIST: 'GET_CUSTOM_MODULE_LIST',
  GET_CUSTOM_MODULE_PAGE_CONTROL_LIST: 'GET_CUSTOM_MODULE_PAGE_CONTROL_LIST',
  GET_CUSTOM_MODULE_PAGE_LIST: 'GET_CUSTOM_MODULE_PAGE_LIST',
  GET_CUSTOM_MODULE_DEPENDENT_CONTROL_LIST: 'GET_CUSTOM_MODULE_DEPENDENT_CONTROL_LIST',
  GET_ALL_CUSTOM_MODULE_FOR_CALCULATION: 'GET_ALL_CUSTOM_MODULE_FOR_CALCULATION',
  GET_CUSTOM_MODULE_CALCULATION_PAGE_LIST: 'GET_CUSTOM_MODULE_CALCULATION_PAGE_LIST',
  GET_CUSTOM_MODULE_PAGE_CONTROL_LIST_FOR_CALCULATION: 'GET_CUSTOM_MODULE_PAGE_CONTROL_LIST_FOR_CALCULATION',
  GET_SYSTEM_CANVAS_CONTROL_TYPES: 'GET_SYSTEM_CANVAS_CONTROL_TYPES',
  GET_SYSTEM_CANVAS_CONTROL_TYPE_BY_ID: 'GET_SYSTEM_CANVAS_CONTROL_TYPE_BY_ID',
  GET_SYSTEM_CANVAS_MODULES: 'GET_SYSTEM_CANVAS_MODULES',
  GET_SYSTEM_CANVAS_MODULE_BY_ID: 'GET_SYSTEM_CANVAS_MODULE_BY_ID',
  GET_SYSTEM_CANVAS_CONTROLS: 'GET_SYSTEM_CANVAS_CONTROLS',
  UPDATE_SYSTEM_CANVAS_MODULE_ACTIVE_STATUS: 'UPDATE_SYSTEM_CANVAS_MODULE_ACTIVE_STATUS',
  UPDATE_SYSTEM_CANVAS_MODULE_ICON: 'UPDATE_SYSTEM_CANVAS_MODULE_ICON',
};

export default customModuleType;
